import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { IconButton, Typography, Grid } from '@material-ui/core';
import Dialog from '../Dialog';
import DocumentList from '../DocumenList';

import SearchBox from '../SearchBox';

import { useState, useEffect } from 'react';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  },
  simpleLabel: {
    display: 'inline-block',
    marginTop: 2
  },
  editHazardFieldsContainer: {
    padding: theme.spacing(2)
  },
  backArrow: {
    marginLeft: -16
  },
  courseName: {
    fontWeight: 600
  },
  addControlButton: {
    marginTop: 8
  }
}));

const DocumentSearchDialog = (props) => {
  const classes = useStyles();
  const { open, documents, handleDocumentClick, handleSearchClosed } = props;

  const [filterdDocuments, setDocuments] = useState(
    documents.filter((x) => x.isFolder === false)
  );

  const [searchTerm, setSerchTerm] = useState('');

  const handleFolderClick = (folder) => {
    // onShowFolderItems(folder.documentName);
  };

  const handleBackButtonClicked = () => {
    // onBackClicked();
  };

  const handleSearchTermChanged = (searchWord) => {
    setSerchTerm(searchWord);
    if (searchWord === '') {
      setDocuments(documents.filter((x) => x.isFolder === false));
    } else {
      var result = documents.filter((o) =>
        o.documentName.toLowerCase().includes(searchWord.toLowerCase())
      );
      /*       .sort(
          (a, b) =>
            a.documentName.toLowerCase().indexOf(searchWord.toLowerCase()) -
            b.documentName.toLowerCase().indexOf(searchWord.toLowerCase())
        ); */
      setDocuments(result.filter((x) => x.isFolder === false));
    }
  };

  const showBackBtn = false;

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleSearchClosed}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          Documents
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {showBackBtn ? (
            <div className={classes.backArrowContainer}>
              <IconButton
                color="inherit"
                onClick={handleBackButtonClicked}
                id="settings-button"
                className={classes.backArrow}
              >
                <ArrowBackIcon color="primary" />
              </IconButton>

              {/* 
              <Typography className={classes.simpleLabel}>
                {' '}
                {currentDirectory}
              </Typography> */}
            </div>
          ) : (
            <div className={classes.backArrowContainer}>
              {/*            <Typography className={classes.simpleLabel}>
                {' '}
                {currentDirectory}
              </Typography> */}
            </div>
          )}
          {filterdDocuments && (
            <div>
              <SearchBox
                className={classes.searchBox}
                handleSearchTermChange={handleSearchTermChanged}
                placeholder="Search Documents"
              />
              <DocumentList
                searchTerm={searchTerm}
                documents={filterdDocuments}
                handleFolderClick={handleFolderClick}
                handleDocumentClick={handleDocumentClick}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions className={classes.footer}>
          <Button
            className={classes.actionButton}
            color="primary"
            variant="outlined"
            onClick={handleSearchClosed}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default DocumentSearchDialog;
